var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 48 49",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#star_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m24 34.92 12.36 7.46-3.28-14.06L44 18.86l-14.38-1.22L24 4.38l-5.62 13.26L4 18.86l10.92 9.46-3.28 14.06L24 34.92Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "star_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  transform: "translate(0 .38)",
  d: "M0 0h48v48H0z"
})))));
export default SvgStar;